import router from '../router'

var mixins = {
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods:{
    // 活动页购买调整转
    activityGoUrl (token,key,s) {
      let routerDate;
      if (token) {
        if(s) {
          routerDate = router.resolve({name: 'ClientProduct', query: {token: token, pid: key, s: s}})
        } else{
          routerDate = router.resolve({name: 'ClientProduct', query: {token: token, pid: key}})
        }
      } else {
        routerDate = router.resolve({name: 'OrderConfirm', params:{productId: key}})
      }
      let {href} = routerDate;
      window.open(href, "_blank")
    }
  }
}

export default mixins;


// WEBPACK FOOTER //
// ./src/mixins/index.js